import type { InventoryFormSchema } from '@/_pages/settings/inventory-kits/shared/schemas/inventory';
import { currencyInput, defaultBooleanValue } from '@/_schemas/generic';
import { defaultStatus } from '@/_schemas/status-input';
import { defaultNumericIdOption } from '@/_shared';

export const defaultValues: Readonly<InventoryFormSchema> = {
  id: -1,
  name: '',
  status: defaultStatus,

  description: '',
  primary_sku: '',
  secondary_skus: [],

  inventory_volume: {
    ...defaultNumericIdOption(),
    quantity: 0,
    primary: defaultBooleanValue(),
  },
  images: [],
  inventory_category: {
    ...defaultNumericIdOption(),
    track_stock_quantities: defaultBooleanValue(),
    track_serial_numbers: defaultBooleanValue(),
  },

  weight: '',
  last_order_cost: currencyInput.defaultValue(),

  current_stock: '0',
  minimum_stock: '',
  maximum_stock: '',

  units_per_order: '',
  minimum_order: '',

  track_stock_quantities: defaultBooleanValue(),
  track_serial_numbers: defaultBooleanValue(),
  discontinued: defaultBooleanValue(),

  manufacturer: '',
  manufacturer_id: '',

  vendors: [],
  logo: [],
  vendor_details: [],
  committed: '0',
} as const;
